function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1246 8.53418H38.9415C46.3715 8.53418 49.7587 12.2251 49.7587 17.0557C49.7587 20.1493 48.1196 22.8092 45.2243 24.3831L52.5449 34.9674H44.7325L38.6136 25.9573H34.9535V34.9674H28.1243V8.53418H28.1246ZM37.1936 20.6382C41.7826 20.6382 42.8207 19.1727 42.8207 17.2185C42.8207 15.1018 41.6735 13.9617 37.8493 13.9617H34.954V20.6379H37.1936V20.6382Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0658 27.8029C84.0658 27.8029 86.9612 30.0283 91.1132 30.0283C93.3531 30.0283 94.7736 29.3771 94.7736 27.9113C94.7736 24.1119 82.4268 24.0033 82.4268 16.0791C82.4268 11.7911 86.0873 7.88281 92.9707 7.88281C96.7402 7.88281 100.783 9.07709 100.783 9.07709L99.7998 14.8306C99.7998 14.8306 96.3578 13.4737 92.9164 13.4737C90.458 13.4737 89.2559 14.1249 89.2559 15.4276C89.2559 19.173 101.493 19.0102 101.493 27.3688C101.493 32.3621 96.959 35.619 91.0041 35.619C86.0327 35.619 82.0992 33.3936 82.0992 33.3936L84.0658 27.8029Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0253601 8.53442H18.8734V13.9622H6.90904V18.9558H16.3057V24.275H6.90904V29.5396H19.4198V34.9674H0.0253601V8.53442Z",
  fill: "#FFCB05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.917 10.8895L112.142 0.759766L117.815 3.08756L112.567 12.5794L107.917 10.8895Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7886 10.1672H62.3611V29.803H68.7886V10.1672Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M81.071 5.60076L77.8575 0.0710449L63.9685 8.0382L67.182 13.5679L81.071 5.60076Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1787 8.04034L53.42 0.147949L50.2064 5.67789L63.9651 13.5703L67.1787 8.04034Z",
  fill: "black"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 36,
    viewBox: "0 0 118 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.f295e6e2.svg";
export { ForwardRef as ReactComponent };